import {useParams, useLocation} from 'react-router-dom';
import queryString from 'query-string';
import {getTransactionIdFromSignPath} from '../../../utils/helpers';

export default function useTransactionIdFromUrl() {
    const params = useParams();
    const {
        pathname,
        search
    } = useLocation();
    const {target} = queryString.parse(search);
    const transactionId = getTransactionIdFromSignPath(target || pathname);

    return transactionId || params.packageId;
}
